// libraries
import React from 'react'

export function UxMenu() {
	return (
		<svg width='51' height='33' viewBox='0 0 51 33' xmlns='http://www.w3.org/2000/svg'><path d='M0 1.5C0 0.671573 0.671573 0 1.5 0H49.5C50.3284 0 51 0.671573 51 1.5C51 2.32843 50.3284 3 49.5 3H1.5C0.671574 3 0 2.32843 0 1.5Z M0 31.5C0 30.6716 0.671573 30 1.5 30H49.5C50.3284 30 51 30.6716 51 31.5C51 32.3284 50.3284 33 49.5 33H1.5C0.671574 33 0 32.3284 0 31.5Z M0 16.5C0 15.6716 0.671573 15 1.5 15H49.5C50.3284 15 51 15.6716 51 16.5C51 17.3284 50.3284 18 49.5 18H1.5C0.671574 18 0 17.3284 0 16.5Z' fill='currentColor' /></svg>
	)
}

export function UxClose() {
	return (
		<svg width='37' height='37' viewBox='0 0 37 37' xmlns='http://www.w3.org/2000/svg'><path d='M0.439339 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L36.5018 34.3805C37.0876 34.9662 37.0876 35.916 36.5018 36.5018C35.916 37.0876 34.9662 37.0876 34.3805 36.5018L0.43934 2.56066C-0.146446 1.97487 -0.146447 1.02513 0.439339 0.43934Z M36.5018 0.439342C37.0876 1.02513 37.0876 1.97488 36.5018 2.56066L2.56068 36.5018C1.9749 37.0876 1.02515 37.0876 0.439364 36.5018C-0.146423 35.916 -0.146423 34.9663 0.439364 34.3805L34.3805 0.439343C34.9663 -0.146443 35.916 -0.146444 36.5018 0.439342Z' fill='currentColor' /></svg>
	)
}

export function UxSpinner() {
	return (
		<svg className='ux-spinner' width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
			<g fill="#5c0120" fillRule="evenodd" clipRule="evenodd">
				<path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z" opacity=".2" />
				<path d="M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z" />
			</g>
		</svg>
	)
}

export function UxSearch() {
	return (
		<svg width='34' height='34' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 34'><path d='M4.4,4.4C7.1,1.7,10.8.2,14.6.2s7.5,1.5,10.2,4.2c2.7,2.7,4.2,6.4,4.2,10.2s-1.2,6.7-3.4,9.2l7.8,7.8c.5.5.5,1.3,0,1.8-.5.5-1.3.5-1.8,0l-7.8-7.8c-2.6,2.2-5.9,3.4-9.2,3.4s-7.5-1.5-10.2-4.2C1.7,22.1.2,18.4.2,14.6S1.7,7.1,4.4,4.4ZM14.6,2.8c-3.1,0-6.2,1.2-8.4,3.5-2.2,2.2-3.5,5.2-3.5,8.4s1.2,6.2,3.5,8.4c2.2,2.2,5.2,3.5,8.4,3.5s6.2-1.2,8.4-3.5c2.2-2.2,3.5-5.2,3.5-8.4s-1.2-6.2-3.5-8.4c-2.2-2.2-5.2-3.5-8.4-3.5Z' fill='currentColor' /></svg>
	)
}
